export const EU_COUNTRIES = [
  'AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'ES', 'FI', 'FR', 'GB', 'GR', 'HR', 'HU', 'IE', 'IS', 'IT', 'LU', 'MT', 'NL', 'NO', 'PL',
  'PT', 'RO', 'SE', 'SI', 'SK', 'AE', 'AU', 'BH', 'CH', 'IL', 'IN', 'KW', 'LB', 'NZ', 'OM', 'QA', 'RU', 'SA', 'TR', 'UA', 'ZA',
];

export const EU_COOKIE_PREFERENCE_NAME = 'eucookiepreference';

export const PS_VISA_STORE_NUMBER_PDC = '1554';

export const PS_VISA_STORE_NUMBER_WEB = '1714';

export const PS_VISA_PATH = '/en-us/playstation-credit-card';

export default { EU_COUNTRIES };
